import React, { useState } from "react";
import { Card, CardBody, Button, Row, Col } from "reactstrap";


const RequerimentoAvisoCard = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <>
      <style>
        {`
          @keyframes avisoEntrada {
            0% { opacity: 0; transform: translateY(-24px) scale(0.97); }
            100% { opacity: 1; transform: translateY(0) scale(1); }
          }
          .aviso-card-wrapper {
            animation: avisoEntrada 0.55s cubic-bezier(0.22, 1, 0.36, 1) forwards;
          }
          .aviso-close-btn {
            background: rgba(0,0,0,0.05);
            border: none;
            color: #777;
            width: 36px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            padding: 0;
            cursor: pointer;
            transition: background 0.2s ease, color 0.2s ease, transform 0.25s ease;
          }
          .aviso-close-btn:hover {
            background: #ff9800 !important;
            color: #fff !important;
            transform: rotate(90deg);
          }
          .aviso-icon-pulse {
            animation: iconPulse 2.5s ease-in-out infinite;
          }
          @keyframes iconPulse {
            0%, 100% { box-shadow: 0 8px 20px rgba(255,152,0,0.3); }
            50% { box-shadow: 0 12px 28px rgba(255,152,0,0.55); }
          }
        `}
      </style>
      <div className="aviso-card-wrapper">
        <Card
          style={{
            border: "none",
            borderRadius: "18px",
            background: "rgba(255, 255, 255, 0.82)",
            backdropFilter: "blur(14px)",
            WebkitBackdropFilter: "blur(14px)",
            boxShadow: "0 16px 40px rgba(0,0,0,0.07), 0 2px 8px rgba(0,0,0,0.04)",
            margin: "0 0 24px 0",
            borderLeft: "7px solid #ff9800",
            overflow: "hidden",
          }}
        >
          <CardBody style={{ padding: "1.5rem 2rem" }}>
            <Row className="align-items-center" style={{ flexWrap: "nowrap", gap: "1rem" }}>
              <Col xs="auto" style={{ paddingRight: 0 }}>
                <div
                  className="aviso-icon-pulse"
                  style={{
                    width: "52px",
                    height: "52px",
                    borderRadius: "14px",
                    background: "linear-gradient(135deg, #ff9800 0%, #e65100 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <i className="fas fa-shield-alt" style={{ fontSize: "24px", color: "#fff" }}></i>
                </div>
              </Col>
              <Col style={{ paddingLeft: "1rem" }}>
                <p
                  style={{
                    fontWeight: "700",
                    fontSize: "0.78rem",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: "#e65100",
                    margin: "0 0 4px 0",
                  }}
                >
                  ATENÇÃO — Informação Importante
                </p>
                <p
                  style={{
                    color: "#333",
                    lineHeight: "1.65",
                    margin: 0,
                    fontSize: "0.97rem",
                  }}
                >
                  As informações prestadas pelo(a) senhor(a) neste requerimento serão validadas por{" "}
                  <strong style={{ color: "#e65100" }}>análise automática</strong> do sistema. Favor realizar o
                  preenchimento de suas informações de maneira que reflitam{" "}
                  <strong style={{ textDecoration: "underline" }}>exatamente</strong> o que consta em seus
                  documentos, evitando assim que seu requerimento seja reprovado durante a validação.
                </p>
              </Col>
              <Col xs="auto" style={{ paddingLeft: 0 }}>
                <button className="aviso-close-btn" onClick={() => setVisible(false)}>
                  <i className="fas fa-times" style={{ fontSize: "14px" }}></i>
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default RequerimentoAvisoCard;
